import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { getDummyNumberCounter, submitTemplate, updateTemplateDetail } from "../../../../utils/numberCounterApi";
import '../../../../assets/css/loader.css';  

//Import Widgets
import WhiteThemeTemplateWidget from "../../../../components/Apps/NumberCounter/Template/WhiteThemeTemplateWidget";
import BlackThemeTemplateWidget from "../../../../components/Apps/NumberCounter/Template/BlackThemeTemplateWidget";
import ColoredNumbersTemplateWidget from "../../../../components/Apps/NumberCounter/Template/ColoredNumbersTemplateWidget";
import ColoredIconsTemplateWidget from "../../../../components/Apps/NumberCounter/Template/ColoredIconsTemplateWidget"; 
import MulticolorCountersTemplateWidget from "../../../../components/Apps/NumberCounter/Template/MulticolorCountersTemplateWidget";
import SingleCounterTemplateWidget from "../../../../components/Apps/NumberCounter/Template/SingleCounterTemplateWidget";

//Import Tabs
import ContentTab from "../../../../components/Apps/NumberCounter/ContentTab";
import LayoutTab from "../../../../components/Apps/NumberCounter/LayoutTab";
import StyleTab from "../../../../components/Apps/NumberCounter/StyleTab";
import SettingTab from "../../../../components/Apps/NumberCounter/SettingTab";

export default function CreateNumberCounter() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("White_Theme_Temp");
    const [selectedLayout, setSelectedLayout] = useState("white_theme_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("white-theme.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Number Counter");
    const [newWidgetName, setNewWidgetName] = useState("");
    const [isTemplateId, setIsTemplateId] = useState(null); 
    const [isNumberCounterIds, setIsNumberCounterIds] = useState([]);
    const [refreshWidgetList, setRefreshWidgetList] = useState(false);
    
    const [numberCounterTabData, setNumberCounterTabData] = useState({
        is_website_frontend: "",  
        widget_title: "",     
        number_of_columns: "",     
        space_between_counters: "30px",   
        tablet_number_of_columns: 2,     
        tablet_space_between_counters: "20px",
        phone_number_of_columns: 2,     
        phone_space_between_counters: "20px",  
        width: "320",  
        position_alignment: "",  
        margin_alignment: "0 auto 0 auto", 
        background_color: "",     
        widget_title_color: "",     
        widget_title_size: "25px",     
        counter_background_color: "",     
        number_color: "",     
        caption_color: "",     
        icon_background_color: "",  
        font_type: "Default",       
        number_size: "38px",       
        caption_size: "18px",       
        icon_font_size: "60px", 
        is_enable_mobile_setting: 1, 
        tablet_number_size: "18px",       
        tablet_caption_size: "18px",       
        tablet_icon_font_size: "20px", 
        phone_number_size: "18px",       
        phone_caption_size: "18px",       
        phone_icon_font_size: "20px",  
        animation_speed: "1 Sec",       
        animation_type: "Ease Out",    
        is_enable_number_formatting: 1,   
        language_type: "English",   
        custom_css: "",   
        custom_js: "",   
    });

    // Set Template Setting And Texts when activeTemplateSection changes
    useEffect(() => {
        let number_of_columns = "";
        let position_alignment = "";
        let background_color = "";
        let widget_title_color = "";
        let counter_background_color = "";
        let number_color = "";
        let caption_color = "";
        let icon_background_color = "";
    
        switch (activeTemplateSection) {
            case "White_Theme_Temp":
                number_of_columns = 3;
                position_alignment = "center";
                background_color = "#fff";
                widget_title_color = "#000";
                counter_background_color = "#fff";
                number_color = "#000";
                caption_color = "#000";
                icon_background_color = "#fff";
                break;
            case "Black_Theme_Temp":
                number_of_columns = 3;
                position_alignment = "center";
                background_color = "#000";
                widget_title_color = "#fff";
                counter_background_color = "";
                number_color = "#fff";
                caption_color = "#fff";
                icon_background_color = "#fff";
                break;
            case "Colored_Numbers_Temp":
                number_of_columns = 3;
                position_alignment = "center";
                background_color = "#ededed";
                widget_title_color = "#444";
                counter_background_color = "";
                number_color = "#FE8100";
                caption_color = "#444";
                icon_background_color = "#444";
                break;
            case "Colored_Icons_Temp":
                number_of_columns = 3;
                position_alignment = "center";
                background_color = "#000";
                widget_title_color = "#fff";
                counter_background_color = "";
                number_color = "#FE8100";
                caption_color = "#fff";
                icon_background_color = "#FE8100";
                break;
            case "Multicolor_Counters_Temp":
                number_of_columns = 3;
                position_alignment = "left";
                background_color = "#fff";
                widget_title_color = "";
                counter_background_color = "";
                number_color = "#000";
                caption_color = "#000";
                icon_background_color = "#fff";
                break;
            case "Single_Counter_Temp":
                number_of_columns = 1;
                position_alignment = "center";
                background_color = "#fff";
                widget_title_color = "#000";
                counter_background_color = "";
                number_color = "#000";
                caption_color = "#444";
                icon_background_color = "#000";
                break;
            default:
                number_of_columns = "";
                position_alignment = "";
                background_color = "";
                widget_title_color = "";
                counter_background_color = "";
                number_color = "";
                caption_color = "";
                icon_background_color = "";
        }
    
        // Update setNumberCounterTabData state with the data
        setNumberCounterTabData((prevData) => ({
            ...prevData,
            number_of_columns: number_of_columns,
            position_alignment: position_alignment,
            background_color: background_color,
            widget_title_color: widget_title_color,
            counter_background_color: counter_background_color,
            number_color: number_color,
            caption_color: caption_color,
            icon_background_color: icon_background_color,
        }));
    
    }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateNumberCounterTabData = (key, value) => {
        setNumberCounterTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = async () => {
        setShowTemplateSelection(false);
        
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        } 

        //Call Api To Create Templates with dummy data first
        try {
            // Limit counter IDs for Single_Counter_Temp
            const filteredCounterIds = activeTemplateSection === "Single_Counter_Temp"
            ? [isNumberCounterIds[0]]
            : isNumberCounterIds;

            // Collect data from refs
            const settingsArray = Object.entries(numberCounterTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Number_Counter",
                number_counter_ids: filteredCounterIds,
                settings: settingsArray, 
            };
            
            //Api Call
            let api_response = await submitTemplate(payload);
            //Check Responce
            if (api_response.status === true) {
                setIsTemplateId(api_response.data.template_id);
                setIsNumberCounterIds(api_response.data.number_counter_ids);
                setIsSubmitting(false);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    }; 

    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getDummyNumberCounter();
                if (templateResult?.status === true && templateResult?.data?.data_list) {
                    // Extracting template IDs properly
                    const templateIds = templateResult.data.data_list.map(number_counter => number_counter.id);
                    setIsNumberCounterIds(templateIds);
                } else {
                    setIsNumberCounterIds([]); 
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(numberCounterTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                number_counter_ids: isNumberCounterIds,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/number-counter');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Number Counter" app_type="Number_Counter" app_slug="number-counter"/>
            {showTemplateSelection ? ( 
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="White_Theme_Temp" data-layout_type="white_theme_layout" data-template_image="white-theme.png" checked={activeTemplateSection === "White_Theme_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/number-counter/templates/white-theme.png`} alt="white-theme" />
                                    </div> 
                                    <div className="content_sub">White Theme</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Black_Theme_Temp" data-layout_type="black_theme_layout" data-template_image="black-theme.png" checked={activeTemplateSection === "Black_Theme_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/number-counter/templates/black-theme.png`} alt="black-theme" />
                                    </div>
                                    <div className="content_sub">Black Theme</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Colored_Numbers_Temp" data-layout_type="colored_numbers_layout" data-template_image="colored-numbers.png" checked={activeTemplateSection === "Colored_Numbers_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/number-counter/templates/colored-numbers.png`} alt="colored-numbers" />
                                    </div>
                                    <div className="content_sub">Colored Numbers</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Colored_Icons_Temp" data-layout_type="colored_icons_layout" data-template_image="colored-icons.png" checked={activeTemplateSection === "Colored_Icons_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/number-counter/templates/colored-icons.png`} alt="colored-icons" />
                                    </div>
                                    <div className="content_sub">Colored Icons</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Multicolor_Counters_Temp" data-layout_type="multicolor_counters_layout"  data-template_image="multicolor-counters.png" checked={activeTemplateSection === "Multicolor_Counters_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/number-counter/templates/multicolor-counters.png`} alt="multicolor-counters" />
                                    </div>
                                    <div className="content_sub">Multicolor Counters</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Single_Counter_Temp" data-layout_type="single_counter_layout" data-template_image="single-counter.png" checked={activeTemplateSection === "Single_Counter_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/number-counter/templates/single-counter.png`} alt="single-counter" />
                                    </div>
                                    <div className="content_sub">Single Counter</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/number-counter/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab isTemplateId={isTemplateId} updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} templateType={activeTemplateSection} setRefreshWidgetList={setRefreshWidgetList}/>
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} />
                            )}
                            {activeSection === "Settings" && (
                              <SettingTab updateNumberCounterTabData={updateNumberCounterTabData} numberCounterTabData={numberCounterTabData} />
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/number-counter"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/number-counter/number-counter.svg`} alt="number-counter"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                            <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/number-counter/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/number-counter" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Number Counter <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "White_Theme_Temp" && (
                      <WhiteThemeTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Black_Theme_Temp" && (
                      <BlackThemeTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList}/>
                    )}

                    {activeTemplateSection === "Colored_Numbers_Temp" && (
                      <ColoredNumbersTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Colored_Icons_Temp" && (
                      <ColoredIconsTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Multicolor_Counters_Temp" && (
                      <MulticolorCountersTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}

                    {activeTemplateSection === "Single_Counter_Temp" && (
                      <SingleCounterTemplateWidget isTemplateId={isTemplateId} numberCounterTabData={numberCounterTabData} refreshWidgetList={refreshWidgetList} />
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 